module.exports = __webpack_public_path__ + "static/media/noData.e02590bb.jpg";